import { FormikProps } from "formik";
import { OpretFirmaStep2Formik } from "../../opretFirmaInterface";
import { useQuery } from "@tanstack/react-query";
import { SelectFormik } from "../../../../formcontrols/Select";
import { get } from "../../../../../api/util";

const OpretFirmaSelskabstype = ({
  formik,
}: {
  formik: FormikProps<OpretFirmaStep2Formik>;
}) => {
  const { data, isLoading, error } = useQuery<{ navn: string; nr: number }[]>({
    queryKey: ["opretFirmaSelskabstype"],
    queryFn: async function () {
      return get({
        query: "kodelister/selskabstype",
      });
    },
  });
  if (error) return <div>Fejl</div>;
  if (isLoading) return <div>Henter koder ...</div>;
  if (!data) return null;
  const selskabstypeData: LabelValueType[] = data.map((e) => {
    return {
      label: e.navn,
      value: e.nr.toString(),
    };
  });
  return (
    <div>
      <SelectFormik
        config={{
          component: "select",
          id: "selskabstype",
          label: "Selskabstype",
          placeholder: "Vælg",
          isRequired: true,
        }}
        data={selskabstypeData}
        formik={formik}
      />
    </div>
  );
};

export default OpretFirmaSelskabstype;
